<main class="verify" aria-labelledby="verify-title">
  <div class="verify__brand" aria-hidden="true">
    <img class="verify__brand-logo" src="assets/logo.svg" alt="LARS logo" i18n-alt="@@Lars_LogoAlt" decoding="async" />
  </div>

  <div class="verify__surface">
    <div class="verify__content">
      <h1 class="verify__title" id="verify-title" i18n="@@VerifyEmailTitle">Please verify your email address</h1>

      <p class="verify__hint" i18n="@@VerifyEmail_Hint">
        We sent you a confirmation email. Please click the link to continue.
      </p>

      <button
        class="verify__button verify__button--primary"
        type="button"
        [disabled]="resendCooldownSeconds > 0"
        (click)="sendMailVerify()"
        >
        @if (resendCooldownSeconds > 0) {
          <ng-container i18n="@@VerifyEmailSendAgainCooldown"
            >Send again in {{ resendCooldownSeconds }}s</ng-container
            >
          } @else {
            <ng-container i18n="@@VerifyEmailSendAgain"
              >Send E-Mail Confirmation again</ng-container
              >
            }
          </button>

          <form class="verify__form" [formGroup]="mailForm" (ngSubmit)="changeMail()">
            <label class="verify__label" for="verify-email-input" i18n="@@VerifyEmailEmailWrong">Email wrong?</label>
            <div class="verify__form-row">
              <input
                id="verify-email-input"
                class="verify__input"
                type="email"
                name="mail"
                formControlName="mail"
                required
                autocomplete="email"
                [attr.aria-invalid]="mailForm.controls['mail']?.invalid ? 'true' : 'false'"
                />
                <button class="verify__button verify__button--secondary" type="submit" i18n="@@VerifyEmailChangeMail">
            Change E-Mail
          </button>
              </div>
            </form>

            <button class="verify__button verify__button--ghost" type="button" (click)="logout()" i18n="@@VerifyEmailLogout">
        Logout
      </button>
          </div>
        </div>
      </main>
